module.exports = "<p>自动旋转</p>\n";